import { HelpFeature, HelpModel } from '@/model/HelpModel';
import { HelpActionTypes } from './actionTypes';
import { HelpAction } from './actions';

//States' definition
const INIT_STATE: HelpState = {
	helpRoutes: new Map(),
};

export type HelpState = {
	helpRoutes: Map<HelpFeature, HelpModel[]>;
};

//Reducers
const helpReducer = (state: Readonly<HelpState> = INIT_STATE, action: HelpAction): HelpState => {
	switch (action.type) {
		case HelpActionTypes.SET_HELP_FEATURES:
			return {
				...state,
				helpRoutes: action.payload,
			};

		default:
			return state;
	}
};

export { helpReducer };
